var ClientType = /* @__PURE__ */ ((ClientType2) => {
  ClientType2["STB"] = "1";
  ClientType2["LEGACY_STB"] = "2";
  ClientType2["ANDROID_TABLET"] = "3";
  ClientType2["ANDROID_MOBILE"] = "4";
  ClientType2["ANDROID_TV"] = "5";
  ClientType2["IOS_MOBILE"] = "7";
  ClientType2["IOS_TABLET"] = "8";
  ClientType2["TVOS_APPLE_TV"] = "9";
  ClientType2["WINDOWS_TABLET"] = "10";
  ClientType2["PLAYSTATION"] = "11";
  ClientType2["XBOX"] = "12";
  ClientType2["CHROMECAST"] = "13";
  ClientType2["SMART_TV"] = "14";
  ClientType2["PC"] = "15";
  ClientType2["MAC"] = "16";
  ClientType2["ROKU"] = "100";
  ClientType2["FIRE"] = "101";
  ClientType2["SAMSUNG"] = "102";
  ClientType2["LG"] = "103";
  return ClientType2;
})(ClientType || {});
function createThinkAnalyticsParamsInterceptor({ clientType }) {
  const match = /GMT([+-]?\d{2})(\d{2})/.exec((/* @__PURE__ */ new Date()).toString());
  const timeZone = `${match[1]}:${match[2]}`;
  return (thinkAnalyticsRequestConfig) => {
    const {
      includeTimeZone,
      includeClientType,
      includeDeviceType,
      method,
      ...axiosRequestConfig
    } = thinkAnalyticsRequestConfig;
    const thinkAnalyticsParams = {
      ...includeTimeZone ? { timeZone } : {},
      ...includeClientType ? { clientType } : {},
      ...includeDeviceType ? { deviceType: clientType } : {}
    };
    const useData = method === "post" || method === "put" || method === "patch";
    if (useData) {
      return {
        method,
        ...axiosRequestConfig,
        data: {
          ...axiosRequestConfig.data,
          ...thinkAnalyticsParams
        }
      };
    }
    return {
      method,
      ...axiosRequestConfig,
      params: {
        ...axiosRequestConfig.params,
        ...thinkAnalyticsParams
      }
    };
  };
}

export { ClientType, createThinkAnalyticsParamsInterceptor };
//# sourceMappingURL=thinkAnalyticsParams.js.map
